import { render, staticRenderFns } from "./SbErrorBoundary.vue?vue&type=template&id=0d8ca2c9"
import script from "./SbErrorBoundary.vue?vue&type=script&lang=js"
export * from "./SbErrorBoundary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports